// ----------------------------------------------------------------------

const ROOTS = {
  AUTH: '/auth',
  ACCOUNT: '/account',
  PAYCARD: '/paycard',
  MANAGEMENT: '/management',
  REPORTS: '/reports',
  IN_STORE: '/in-store-reports',
  MISC: '/misc',
  ABOVE_STORE: '/above-store',
  REPORT_BUILDER: '/report-builder',
};

// ----------------------------------------------------------------------

export const paths = {
  root: '/',
  chat: '/chat',
  helpInsights: 'https://www.onedatasource.com/oneview/help-insights/',
  page403: '/403',
  page404: '/404',
  page500: '/500',
  // AUTH
  auth: {
    signIn: `${ROOTS.AUTH}/sign-in`,
    signUp: `${ROOTS.AUTH}/sign-up`,
    addAccount: `${ROOTS.AUTH}/add-account`,
    updatePassword: `${ROOTS.AUTH}/update-password`,
    requestReset: `${ROOTS.AUTH}/request-reset`,
    verify: `${ROOTS.AUTH}/verify`,
  },
  // ACCOUNT
  account: {
    root: ROOTS.ACCOUNT,
    addAccount: `${ROOTS.ACCOUNT}/add-account`,
  },
  // REPORTING
  dashboards: {
    list: `/dashboards`,
    view: (id) => `/dashboards${id}`,
  },
  reports: {
    root: `${ROOTS.REPORTS}`,
    list: `${ROOTS.REPORTS}/list`,
    schedules: `${ROOTS.REPORTS}/schedules`,
    view: (id) => `${ROOTS.REPORTS}${id}`,
  },
  // REPORTING
  reporting: {
    root: `${ROOTS.IN_STORE}`,
    list: `${ROOTS.IN_STORE}/list`,
    view: `${ROOTS.IN_STORE}/view`,
    schedules: `${ROOTS.IN_STORE}/schedules`,
  },
  // REPORT BUILDER
  reportBuilder: {
    root: ROOTS.REPORT_BUILDER,
    view: `${ROOTS.REPORT_BUILDER}/view`,
    list: `${ROOTS.REPORT_BUILDER}/list`,
  },
  // ENVYSION (under /reports, so the Reports menu stays open on these pages)
  envysion: {
    cameraView: `${ROOTS.REPORTS}/envysion/camera-view`,
    ticketViewPh: `${ROOTS.REPORTS}/envysion/ticket-view-ph`,
    ticketViewTb: `${ROOTS.REPORTS}/envysion/ticket-view-tb`,
  },
  inStoreReports: {
    root: `${ROOTS.IN_STORE}`,
    list: `${ROOTS.IN_STORE}/list`,
    view: `${ROOTS.IN_STORE}/view`,
    viewReport: (brand, category, report) => `${ROOTS.IN_STORE}/view?brand=${brand}&category=${category}&report=${report}`,
    schedules: {
      root: `${ROOTS.IN_STORE}/schedules`,
      list: `${ROOTS.IN_STORE}/schedules/list`,
      new: `${ROOTS.IN_STORE}/schedules/new`,
      edit: (id) => `${ROOTS.IN_STORE}/schedules/${id}/edit`,
      view: (id) => `${ROOTS.IN_STORE}/schedules/${id}/view`,
    },
  },
  // DASHBOARD
  paycard: {
    root: `${ROOTS.PAYCARD}`,
    rapidCards: `${ROOTS.PAYCARD}/rapid-cards`,
    config: `${ROOTS.PAYCARD}/config`,
    rapidConfig: `${ROOTS.PAYCARD}/rapid-config`,
    rapidDisbursementConfig: `${ROOTS.PAYCARD}/rapid-disbursement-config`,
    akimboDistributorMap: `${ROOTS.PAYCARD}/akimbo-distributor-map`,
    payments: `${ROOTS.PAYCARD}/payments`,
    employees: {
      list: `${ROOTS.PAYCARD}/employees`,
      edit: (id) => `${ROOTS.PAYCARD}/employees/${id}/edit`,
      view: (id) => `${ROOTS.PAYCARD}/employees/${id}/view`,
      new: `${ROOTS.PAYCARD}/employees/new`,
    },
  },
  // MANAGEMENT
  management: {
    root: `${ROOTS.MANAGEMENT}`,
    user: {
      root: `${ROOTS.MANAGEMENT}/user`,
      list: `${ROOTS.MANAGEMENT}/user/list`,
      new: `${ROOTS.MANAGEMENT}/user/new`,
      view: (id) => `${ROOTS.MANAGEMENT}/user/${id}/view`,
      edit: (id) => `${ROOTS.MANAGEMENT}/user/${id}/edit`,
    },
    store: {
      root: `${ROOTS.MANAGEMENT}/store`,
      list: `${ROOTS.MANAGEMENT}/store/list`,
      new: `${ROOTS.MANAGEMENT}/store/new`,
      view: (id) => `${ROOTS.MANAGEMENT}/store/${id}/view`,
      edit: (id) => `${ROOTS.MANAGEMENT}/store/${id}/edit`,
    },
    coupon: {
      root: `${ROOTS.MANAGEMENT}/coupon`,
      list: `${ROOTS.MANAGEMENT}/coupon`,
    },
  },
  // MISC
  misc: {
    alignmentAssignment: `${ROOTS.MISC}/alignment-assignment`,
  },
  // ABOVE STORE
  aboveStore: {
    root: `${ROOTS.ABOVE_STORE}`,
    acct: {
      gl: {
        root: `${ROOTS.ABOVE_STORE}/acct/gl`,
        list: `${ROOTS.ABOVE_STORE}/acct/gl/list`,
      },
      amounts: {
        root: `${ROOTS.ABOVE_STORE}/acct/amounts`,
        setup: `${ROOTS.ABOVE_STORE}/acct/amounts/setup`,
      },
    },
  },
};
